import { Box, IconButton } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { ReactComponent as CloseIcon } from '../Icons/close.svg';
import '../Styles/Modal.css';
import Input from './Input';

function ChangePassDialog({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const [loading, setLoading] = useState(false);

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const [errorMessage, setErrorMessage] = useState('');

  const handleShowPassword = (type) => () => {
    if (type === 'confirmPassword')
      setShowPassword((st) => ({
        ...st,
        confirmPassword: !st.confirmPassword,
      }));
    else
      setShowPassword((st) => ({
        ...st,
        password: !st.password,
      }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log('name,value', name, value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    if (
      !validatePassword(formData.confirmPassword) ||
      formData.confirmPassword !== formData.password
    ) {
      setErrorMessage(
        'Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character. Password and confirm password must be same.'
      );
      return;
    }
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user'));
    await axios
      .request({
        method: 'PATCH',
        url: `${process.env.REACT_APP_BASE_URL}/api/v1/authentication/resetPassword`,
        data: {
          password: formData.password,
          id: user?._id || '',
        },
      })
      .then(() => {
        toast.success('Password changed successfully');
        onClose();
      })
      .catch((err) => {
        setErrorMessage(err?.response?.data?.message || 'Something went wrong');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return isOpen ? (
    <div className='modal-overlay'>
      <div className='modal'>
        <div className='Upper-modal-row'>
          <h2>Change Password</h2>
          <CloseIcon
            onClick={() => {
              onClose();
              setFormData({ email: '' });
            }}
          />
        </div>
        <form onSubmit={handleSubmit}>
          <div className='row' style={{ flexDirection: 'column', gap: '20px' }}>
            <div className='input-boxer'>
              <Box position='relative'>
                <Input
                  type={showPassword.password ? 'text' : 'password'}
                  placeholder='Enter Password'
                  name='password'
                  value={formData.password}
                  onChange={handleInputChange}
                  style={{
                    width: '-webkit-fill-available',
                  }}
                  required={true}
                />
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-30%)',
                  }}
                  onClick={handleShowPassword('password')}
                >
                  {showPassword.password ? <FaEye /> : <FaEyeSlash />}
                </IconButton>
              </Box>
              <Box position='relative'>
                <Input
                  type={showPassword.confirmPassword ? 'text' : 'password'}
                  placeholder='Confirm Password'
                  name='confirmPassword'
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  style={{
                    width: '-webkit-fill-available',
                  }}
                  required={true}
                />
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-30%)',
                  }}
                  onClick={handleShowPassword('confirmPassword')}
                >
                  {showPassword.confirmPassword ? <FaEye /> : <FaEyeSlash />}
                </IconButton>
              </Box>
            </div>
          </div>
          {errorMessage && (
            <div style={{ color: 'red', marginTop: '15px' }}>
              {errorMessage}
            </div>
          )}
          <button
            className='continue-modal-button'
            style={{ width: '100%' }}
            type='submit'
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  ) : null;
}

export default ChangePassDialog;
